import type { SubdomainCheck } from "../../../lib/api";
import { siteHost } from "../../../lib/domains";

export function SubdomainHint({ check, subdomain }: { check: SubdomainCheck | null; subdomain: string }) {
  if (!subdomain.trim()) return null;
  if (!check) return <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>Checking…</div>;
  if (!check.valid) {
    return <div style={{ color: "#b91c1c", fontSize: 12, marginTop: 4 }}>
      Use 3–32 lowercase letters/numbers/hyphens, no leading or trailing hyphen.
    </div>;
  }
  if (!check.available) {
    return <div style={{ color: "#b91c1c", fontSize: 12, marginTop: 4 }}>
      {check.reason === "reserved" ? "That name is reserved." : "That subdomain is already taken."}
    </div>;
  }
  return <div style={{ color: "#047857", fontSize: 12, marginTop: 4 }}>
    ✓ {siteHost(subdomain)} is available
  </div>;
}
